import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import Tip from '../components/Tip';
import sharedContainer from './TipSharedContainer';
import { getTipEnabledForBarber } from '../../barbers/selectors';
import { getNoExtrasForReserveNoPay } from '../../shops/selectors';
import WithApplePayQuery from '../../hoc/WithApplePayQuery';
import WithKioskProp from '../../hoc/WithKioskProp';
import WithTimeWaitingList from '../../hoc/WithTimeWaitingList';

export default compose(
  withRouter,
  WithApplePayQuery,
  WithKioskProp,
  WithTimeWaitingList,
  connect((state, ownProps) => {
    const tipEnabledForBarber = getTipEnabledForBarber(state, ownProps.params.barberRoute);
    const noExtrasForReserveNoPay = getNoExtrasForReserveNoPay(state, ownProps.params.shopRoute);

    return {
      tipEnabled: tipEnabledForBarber
        && (!noExtrasForReserveNoPay || ownProps.withApplePay)
        && !ownProps.kiosk,
    };
  }),
  sharedContainer,
)(Tip);



// WEBPACK FOOTER //
// ./src/app/reservation/containers/Tip.js